import React from 'react';
import { connect } from 'react-redux';

import ScenarioInfo from './ScenarioInfo';
import ScenarioQuestions from './ScenarioQuestions';
import ActorQuestions from './ActorQuestions';
import ScenarioNotes from './ScenarioNotes';
import ActorNotes from './ActorNotes';

import "./Room.css";

const Scenario = ({ isRoomHost }) => {
    return (
        <div className='row'>
            <ScenarioInfo />

            {isRoomHost ? <ScenarioQuestions /> : <ActorQuestions />}

            {isRoomHost ? <ScenarioNotes /> : <ActorNotes />}
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(Scenario);